<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Asignar Coevaluaciones",
            items: [
                {
                text: "Utility",
                href: "/"
                },
                {
                text: "Starter Page",
                active: true
                }
            ],
            filtro:{
                colegio:''
            },
            colegios:[],
            usuarios:[],
            funcionarios:[]
        };
    },
    methods:{
        actualizar(){
            if (this.user.rol_id==1) {
                axios.get('/api/get_colegios').then(res=>{
                    this.colegios = res.data.colegios;
                });
            }
            else if (this.user.rol_id==2) {
                this.filtro.colegio=this.user.colegio_id;
                this.buscar();
            }
        },
        buscar(){
            axios.get('/api/get_usuarios_instrumentos/'+this.filtro.colegio).then(res=> {
                if(res.data.estado){
                    this.usuarios = res.data.usuarios
                    //console.table(this.Usuarios);
                }
            });
            axios.get('/api/get_personas_colegio/'+this.filtro.colegio).then(res=>{
                this.funcionarios = res.data.users;
            });
        },
        actualizar_autoevaluacion(data){
            console.log(data);
            axios.post('/api/asignar_autoevaluacion',data).then(res=> {
                if(res.data.estado){
                    Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: res.data.mensaje,
                    showConfirmButton: false,
                    timer: 1500
                    })
                    //console.log(res.data.mensaje);
                }
            });
        },
        actualizar_coevaluacion(data){
            axios.post('/api/asignar_coevaluacion',data).then(res=> {
                if(res.data.estado){
                    Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: res.data.mensaje,
                    showConfirmButton: false,
                    timer: 1500
                    })
                    //console.log(res.data.mensaje);
                }
            });
        },
    },
    created(){
        this.actualizar();
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <b-button class="float-right ml-2" variant="primary" href="/app/agregar/usuarios">Usuarios</b-button>
                            </div>
                        </div>
                        <div class="card p-3 mt-2 bg-soft-primary" v-if="user.rol_id==1">
                            <div class="row">
                                <div class="offset-md-2 col-md-6">
                                    <div class="form-group row">
                                        <label class="col-md-3 pt-1 font-size-16 text-right">Colegio :</label>
                                        <div class="col-md-9">
                                            <select class="custom-select" v-model="filtro.colegio" @change="buscar()">
                                                <option selected value="">Seleccione colegio</option>
                                                <option v-for="colegio in colegios" :key="colegio.id" :value="colegio.id">{{colegio.nombre.toUpperCase()}}-{{colegio.comuna_nombre}}-{{colegio.region_nombre}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2 text-right">
                                    <b-button variant="primary" block @click="buscar()">Buscar</b-button>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <p>*Los coevaluadores corresponden a personas que coevaluará el nombre principal</p>
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table table-hover mb-0">
                                        <thead>
                                            <tr>
                                                <th>Nº</th>
                                                <th>Nombre </th>
                                                <th>Rut</th>
                                                <th>Instrumento</th>
                                                <th>Autoevaluación</th>
                                                <th>Coevaluador 1*</th>
                                                <th>Coevaluador 2*</th>
                                                <th>Coevaluador 3*</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(usuario,index ) in usuarios" :key="index">
                                                <th>{{index+1}}</th>
                                                <td>{{usuario.nombre}} {{usuario.apellidoPaterno}} {{usuario.apellidoMaterno}}</td>
                                                <td nowrap>{{usuario.rut}}-{{usuario.rut_dv}}</td>
                                                <td>{{usuario.datainstrumento.nombre}}</td>
                                                <td>
                                                    <b-form-checkbox for="text" v-model="usuario.autoevaluacion" @change="actualizar_autoevaluacion(usuario)"></b-form-checkbox>
                                                </td>
                                                <td>
                                                    <select class="custom-select" v-model="usuario.coevaluador1" @change="actualizar_coevaluacion(usuario)">
                                                        <option selected :value="null">Seleccione coevaluador 1</option>
                                                        <option v-for="funcionario in funcionarios" :key="funcionario.id" :value="funcionario.id" >{{funcionario.nombre}} {{funcionario.apellidoPaterno}} {{funcionario.apellidoMaterno}}</option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <select class="custom-select" v-model="usuario.coevaluador2" @change="actualizar_coevaluacion(usuario)" :disabled="usuario.coevaluador1==null?true:false">
                                                        <option selected :value="null">Seleccione coevaluador 2</option>
                                                        <option v-for="funcionario in funcionarios" :key="funcionario.id" :value="funcionario.id" >{{funcionario.nombre}} {{funcionario.apellidoPaterno}} {{funcionario.apellidoMaterno}}</option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <select class="custom-select" v-model="usuario.coevaluador3" @change="actualizar_coevaluacion(usuario)" :disabled="usuario.coevaluador2==null?true:false">
                                                        <option selected :value="null">Seleccione coevaluador 3</option>
                                                        <option :value="null">No aplica</option>
                                                        <option v-for="funcionario in funcionarios" :key="funcionario.id" :value="funcionario.id" >{{funcionario.nombre}} {{funcionario.apellidoPaterno}} {{funcionario.apellidoMaterno}}</option>
                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>